import { render, staticRenderFns } from "./OnlineDiscuss.vue?vue&type=template&id=d3ce9e44&scoped=true&"
import script from "./OnlineDiscuss.vue?vue&type=script&lang=js&"
export * from "./OnlineDiscuss.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/project-detail.css?vue&type=style&index=0&id=d3ce9e44&scoped=true&lang=css&"
import style1 from "./OnlineDiscuss.vue?vue&type=style&index=1&id=d3ce9e44&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3ce9e44",
  null
  
)

export default component.exports